/// <reference path="../../../typings/globals/jquery/index.d.ts" />
/**
 * Strefa dystrybutora
 *
 * @export
 * @class dZone
 */

export class DealersZone {
	constructor(options) {
		let defaults = {
			urlAddonGetCats: 'get=brandCategories',
			urlAddonGetItems: 'get=simpleProductList',
			urlAddonGetItemData: 'get=poductMaterials',
			boxIndex: 0,
			prevBoxIndex: null,
			formatCategoriesMode: null, // ustawiane w JSON -> pick 1 lub pick 2 - wybór poziomu kategorii 1 lub 2, all - dwa poziomy 1:2
		};
		this.settings = $.extend({}, defaults, options);
		this.settings.maxIndex = $(".naviBox").length-2; // "-2" za next i prev

		this.testMode = false;
		this.cache = {};

		this.schemas = {
			'categories': '<p id="naviBoxListGetProduct__index__" class="naviBoxListElement naviBoxListGetProduct" data-cat-id="__id__">__name__</p>',
			'product': '<p id="naviBoxListGetMaterials__index__" class="naviBoxListElement naviBoxListGetMaterials" data-item-id="__id__">__name__</p>'
		};

		this.break2Cols = 585; // powyzej 2 kolumny
		this.break3Cols = 885; // powyzej 3 kolumny
		this.cols = null;
		this.activeCol = null;

		this.init();
	}

	// ****************************************************************************************************
	// Inicjalizacja Strefy
	// ****************************************************************************************************
	init() {
		this.initClikEvent(0);
		this.adjustNavi();
		this.initNextPrevBtns();
	}

	// ****************************************************************************************************
	// Inicjalizacja Strefu
	// ****************************************************************************************************
	test() {
		console.log(this.cache);
	}

	// ****************************************************************************************************
	// zdekodowanie adresu do pobierania
	// ****************************************************************************************************
	decodeCategorieUrl( url, addOn, atm=null ) {
//console.log('decodeCategorieUrl',url, addOn, atm);

		if ( url.includes('?') ) {
			url = url.split('?')
			return url[0] + atm + '/st-1?' + url[1] + '&' + addOn;
		}
		return url + atm + '/st-1?' + addOn;
	}

	// ****************************************************************************************************
	// zmiana ID w URL
	// ****************************************************************************************************
	changeIdInUrl( url, id ){
//console.log('changeIdInUrl',url, id);
		if ( url.includes('cat-') ) {
			url = url.split('cat-');
			return url[0] + 'cat-' + id;
		}
		if ( url.includes('/items') ) {
			url = url.split('/items');
			return '/listing/cat-'+id+url[1];
		}

		return url;
	}

	// ****************************************************************************************************
	// zmiana PAGE w URL
	// ****************************************************************************************************
	changePageInUrl( url, page ){
//console.log('changePageInUrl',url, page);
		if ( url.includes('/pg-') ) {
			url = url.replace(/\/pg-[0-9]+/, '/pg-'+page);
		} else {
			url = url.replace('?', '/pg-'+page+'?');
		}
		return url;
	}

	// ****************************************************************************************************
	// pobranie danych
	// ****************************************************************************************************
	getData(boxIndex, url, btnId, page=1) {
//console.log('getData',boxIndex, url, btnId, page);
		var that = this;
		var rowData, json = null;
		var box = '#naviBox'+boxIndex;
		var showLoading = true;

		if ( page > 1 ) {
			$(box).append('<div id="naviBoxMorePage'+page+'" class="naviBoxMorePage empty text-center"><div class="spinner-grow spinner-grow-sm text-primary" role="status"></div><div class="spinner-grow spinner-grow-sm text-primary" role="status"></div><div class="spinner-grow spinner-grow-sm text-primary" role="status"></div></div>')
			box = '#naviBoxMorePage'+page;
			showLoading = false;
		}

		toolsObj.ajaxLoadData({
			updateBrowserHistory: false,
			url: url,
			target: box, // fakewe wskazanie na cel
			loadingMode: showLoading,
			loadingTarget: box,
			forceAjaxPageLoad: true,
			getDataMode: true,
			sourceOfError: 'dZone::getData',
			onBeforeSend: function(){
				var boxId = $('#'+btnId).closest('.naviBox').attr('id');
				$('#'+boxId+' .naviBoxListElement.active').removeClass('active');
				$('#'+btnId).addClass('active');

				if ( boxIndex == 3 ) {
					$(box).addClass('empty');
				}
			},
			getData: function (data) {
				if ( data !== undefined ) {
					if ( data.includes('noaccess') )
						location.reload();
					if ( data.includes('DOCTYPE') )
						data = false;
					rowData = data;
				} else {
					console.log('dZone::getData');
					loggerObj.addCustomError('Brands categories not downloaded', 'dZone::getData');
				}
			},
			onComplete: function(){
				json = null;
				if ( boxIndex == 1 ) {
					that.preparePrintDataToBox( that.formatBrandCategories(rowData), boxIndex, 'categories' );
				} else if ( boxIndex == 2 ) {
					json = that.formatItems(rowData);

					if ( json.liczba_stron !== undefined ) {
						let strona = Number(json.strona);
						let liczba_stron = Number(json.liczba_stron);

						if ( strona == 1 ) {
							that.preparePrintDataToBox( json, boxIndex, 'product' );
						} else {
							$(box).removeClass('empty').removeClass('text-center');
							that.preparePrintDataToBox( json, boxIndex, 'product', box );
						}

						if ( strona < liczba_stron ) {
//console.log('preparePrintDataToBox PAGES: ',strona,'/',liczba_stron);
							that.getData(boxIndex, that.changePageInUrl(url, strona+1), btnId, strona+1);
						}
					} else {
						that.preparePrintDataToBox( json, boxIndex, 'product' );
					}
				} else if ( boxIndex == 3 ) {
					that.preparePrintProductToBox( rowData, boxIndex );

					toolsObj.scrollTo('#naviBox'+that.settings.maxIndex, -20);
				}
			}
		});
	}

	// ****************************************************************************************************
	// przygotowanie dodania zawartości do boxu
	// ****************************************************************************************************
	preparePrintDataToBox(json, boxIndexTarget, schema, addModeBox=false) {
//console.log('preparePrintDataToBox', boxIndexTarget, schema);

		this.changeBoxIndex(boxIndexTarget);
		this.printDataToBox(json, schema, addModeBox);
		this.initNextPrevBtns();

		this.initClikEvent(this.settings.boxIndex);

		this.cacheData();
	}

	// ****************************************************************************************************
	// przygotowanie wyswietlenia materiałów
	// ****************************************************************************************************
	preparePrintProductToBox(html, boxIndexTarget) {
//console.log('preparePrintProductToBox', boxIndexTarget);

		this.changeBoxIndex(boxIndexTarget);
		this.printProductToBox(html);
		this.initNextPrevBtns();

		$('.naviBoxTop').off('click').on('click', function(){
			toolsObj.scrollTo('#dZone', -20);
		});

		this.initClikEvent(this.settings.boxIndex);

		this.cacheData();
	}

	// ****************************************************************************************************
	// zmiana indexu boxu
	// ****************************************************************************************************
	changeBoxIndex(boxIndexTarget) {
		if ( boxIndexTarget <= this.settings.maxIndex ) {
			this.settings.prevBoxIndex = this.settings.boxIndex;
			this.settings.boxIndex = boxIndexTarget;
		}
//console.log('changeBoxIndex', this.settings.boxIndex, this.settings.prevBoxIndex);
	}

	// ****************************************************************************************************
	// zmiana indexu boxu
	// ****************************************************************************************************
	clearBoxes(boxIndexTarget) {
//console.log('clearBoxes', boxIndexTarget,'/',this.settings.maxIndex);
		for (let i = boxIndexTarget; i <= this.settings.maxIndex; i++) { // następny box, a nie zrodlowy
			$('#naviBox'+i).html("");
		}
	}

	// ****************************************************************************************************
	// dopasowanie nawigacji do szerokości ekrnu
	// ****************************************************************************************************
	adjustNavi(){
//console.log('adjustNavi', $(window).width() );
		let width = $(window).width();

		if ( this.activeCol === null )
			this.activeCol = this.settings.boxIndex;

		if ( width > this.break3Cols ) {
			this.cols = 3;

		} else if ( width > this.break2Cols ) {
			//this.cols = 2;
			this.cols = 1;
			this.activeCol = 0;

		} else {
			this.cols = 1;
			this.activeCol = 0;
		}


	}

	// ****************************************************************************************************
	// obsługa przycisków mobile do przełączania okienek
	// ****************************************************************************************************
	initNextPrevBtns(){
		let that = this;
//console.log('initNextPrevBtns activeCol:', that.activeCol, ' boxIndex:', that.settings.boxIndex, ' prevBoxIndex:', that.settings.prevBoxIndex);
		$('.changeNaviBox').off('click');

		that.visibilityNextPrevBtn();

		if ( that.cols == 3 ) { // desktop
			that.activeCol = that.settings.boxIndex;
		} else { // mobile
			that.switchNaviBox();

			//if ( that.cols == 1 ) { // mobile 1 okno

				//if ( that.settings.boxIndex > 0 ){
					$('.changeNaviBox').on('click', function(){
//console.log('CLICK0 initNextPrevBtns activeCol:', that.activeCol, ' boxIndex:', that.settings.boxIndex, ' prevBoxIndex:', that.settings.prevBoxIndex);
						let btn = $(this);
						let step = ( btn.attr('id') == 'naviBoxNext') ? 1 : -1;

						if ( !btn.hasClass('disabled') ) {
							if ( that.settings.boxIndex == 2 && step > 0 ) {
							//	that.printCacheToBox( 2 );
							//	that.visibilityNextPrevBtn();
							} else {
								if ( that.settings.boxIndex == 3 && step < 0 ) {
									$('#naviBox3').html('');
									//$('#naviBox2 .active').removeClass('active');
									step*=2;
								}

								that.changeBoxIndex(that.settings.boxIndex + step);
								that.switchNaviBox();
								that.visibilityNextPrevBtn();
							}

							if ( that.settings.boxIndex == 2 && step > 0 ) {
//console.log('------------CLICK CACHE');
								that.printCacheToBox( 2 );
								that.changeBoxIndex( 3 );
								that.switchNaviBox();
								that.visibilityNextPrevBtn();
							}
						}

//console.log('CLICK1 initNextPrevBtns activeCol:', that.activeCol, ' boxIndex:', that.settings.boxIndex, ' prevBoxIndex:', that.settings.prevBoxIndex);
					})
				//}
			//	}
		}
	};

	// ****************************************************************************************************
	// określenie widoczności przycisków next/prev
	// ****************************************************************************************************
	visibilityNextPrevBtn(){
		let next = $('#naviBoxNext');
		let prev = $('#naviBoxPrev');

		next.addClass('disabled');
		prev.addClass('disabled');

		if ( this.cols < 3 ) {
			if ( this.settings.boxIndex > 0 ) {
				prev.removeClass('disabled');

			}

			if ( $('.naviBox.active .naviBoxListElement.active').hasClass('cached') && this.settings.boxIndex < 3 ) {
				next.removeClass('disabled');
			}
		}
	}

	// ****************************************************************************************************
	// animacja przejścia okienka (tylko mobile)
	// ****************************************************************************************************
	switchNaviBox(){
		let hideLeft,showLeft,width,elToHide,elToShow;
		if ( this.activeCol != this.settings.boxIndex && this.settings.boxIndex < 3 && this.cols < 3 ) {
			elToHide = $('#naviBox'+this.activeCol);
			elToShow = $('#naviBox'+this.settings.boxIndex);

			hideLeft = Number(elToHide.css("left").replace('px',''));
			showLeft = Number(elToShow.css("left").replace('px',''));
			width = elToHide.width();
//console.log('switchNaviBox', hideLeft, showLeft, width);

			elToHide.data('saved-left', hideLeft );
			elToShow.data('saved-left', showLeft );

			elToHide.animate({
				left: hideLeft - width
			}, 500).removeClass('active');

			elToShow.animate({
				left: hideLeft
			}, 500).addClass('active');

			this.activeCol = this.settings.boxIndex;
		}
	}

	// toDo: wywalić jeśli nie uzywane
	getCssProperty(elmId, property){
		var elem = document.getElementById(elmId);
		return window.getComputedStyle(elem,null).getPropertyValue(property);
	 }

	// ****************************************************************************************************
	// Wpisanie zawartości do boxu z JSON
	// ****************************************************************************************************
	printDataToBox(json, schema, addModeBox) {
//console.log('printDataToBox',schema);
		var that = this;
		let html = "";

		if ( this.settings.prevBoxIndex == this.settings.boxIndex ) {
			that.removeClikEvent(this.settings.boxIndex);
		}

		if ( json === false ) {
			html = TXT_STREFA_BRAK;
		} else {
			for ( let i in json.elements ) {
				html += that.schemas[schema].replace('__index__', i).replace( '__id__', json.elements[i].id ).replace( '__name__', json.elements[i].nazwa );
			}
		}

		if ( addModeBox !== false )
			$(addModeBox).html(html);
		else
			$('#naviBox'+this.settings.boxIndex).html(html);
	}

	// ****************************************************************************************************
	// Wpisanie zawartości do boxu z JSON
	// ****************************************************************************************************
	printProductToBox(html) {
//console.log('printProductToBox');
		var that = this;

		if ( this.settings.prevBoxIndex == this.settings.boxIndex ) {
			that.removeClikEvent(this.settings.boxIndex);
		}

		$('#naviBox'+this.settings.boxIndex).removeClass('empty').html(html);
	}

	// ****************************************************************************************************
	// usuniecie eventu click
	// ****************************************************************************************************
	removeClikEvent(boxIndex) {
//console.log('removeClikEvent',boxIndex);
		$('#naviBox'+boxIndex+' .naviBoxListElement').off('click');
	}

	// ****************************************************************************************************
	// dodanie eventu click
	// ****************************************************************************************************
	initClikEvent(boxIndex) {
		var that = this;

		for (let i = boxIndex; i >= 0; i--) {
//console.log('initClikEvent',i);
			$('#naviBox'+i+' .naviBoxListElement').each(function(j, e){
				$(e).off('click').on('click', function(){
					let btn = $(this);
					let boxIndex = that.settings.boxIndex;
//console.log('click', btn.html(), 'activeCol:', that.activeCol, ' boxIndex:', that.settings.boxIndex, ' prevBoxIndex:', that.settings.prevBoxIndex);


					that.clearBoxes(i+1); // następny box

					if ( btn.hasClass('cached') && btn.data('cache-id') !== null ) {
						$('#naviBox'+i+' .naviBoxListElement.active').removeClass('active');
						btn.addClass('active');
						that.printCacheToBox( i );
					} else {
						that.getDataClickEvent(btn, i);
					}

					that.changeBoxIndex(boxIndex + 1);
					that.switchNaviBox();
					that.visibilityNextPrevBtn();
				});
			});
		}
	}

	// ****************************************************************************************************
	// Pobranie danych
	// ****************************************************************************************************
	getDataClickEvent(btn, boxIndex){
//console.log('getDataClickEvent',btn, boxIndex);
		var that = this;
		switch (boxIndex) {
			case 0: // kategorie
				that.settings.formatCategoriesMode = btn.data('cat-format');
				that.getData(
					1,
					that.decodeCategorieUrl( btn.data('base-url'), that.settings.urlAddonGetCats, btn.data('brand-atm') ),
					btn.attr('id')
				);
				break;
			case 1: // produkty
				that.getData(
					2,
					that.decodeCategorieUrl( that.changeIdInUrl( $('#naviBox0 .active').data('base-url'), btn.data('cat-id') ), that.settings.urlAddonGetItems, $('#naviBox0 .active').data('brand-atm') ),
					btn.attr('id')
				);
				break;
			case 2: // materialy
				$('.productNaviBox').html('');
				that.getData(
					3,
					'/listing/item-'+btn.data('item-id')+'?'+that.settings.urlAddonGetItemData,
					btn.attr('id')
				);
				break;

			default:
				break;
		}
	}

	// ****************************************************************************************************
	// Zapis zawartości z boxu do CACHE
	// ****************************************************************************************************
	cacheData(){
		let cacheId;
		let elem;

		for (let i = this.settings.maxIndex; i >= 0; i--) {
			elem = $('#naviBox'+i+' .active');
			if ( elem.length > 0 ) {
				if ( elem.data('cache-id') !== undefined ) {
					cacheId = elem.data('cache-id');
				} else {
					cacheId = Date.now();
					elem.attr('data-cache-id', cacheId).addClass('cached');
				}

				this.cache[cacheId] = $('#naviBox'+(i+1)).html();
			}
		}
	}

	// ****************************************************************************************************
	// Wpisanie zawartości do boxu z CACHE
	// ****************************************************************************************************
	printCacheToBox(boxId){
		let cacheId, nextBox;
		let limiter = ( this.cols < 3 ) ? boxId : this.settings.maxIndex;

//console.log('printCacheToBox INIT',boxId, ' maxIndex:', this.settings.maxIndex );

		for (let i = boxId; i<=limiter; i++) {
			nextBox = i+1;
			cacheId = $('#naviBox'+i+' .active').data('cache-id');
			if ( cacheId !== undefined ) {
//console.log('printCacheToBox',cacheId, 'box: ',i,'/',this.settings.maxIndex);
				this.changeBoxIndex(nextBox);
				$('#naviBox'+nextBox).html(this.cache[cacheId]);
			} else
				break;
		}

		this.initClikEvent(this.settings.boxIndex);
	}

	// ****************************************************************************************************
	// obróbka danych kategorii
	// ****************************************************************************************************
	formatBrandCategories(data) {
		if ( data === false )
			return false;

		var json = toolsObj.stringToJson(data, this.testMode);
//console.log('formatBrandCategories',json);

		if ( this.settings.formatCategoriesMode == "pick1" )
			return this.formatBrandCategoriesPickLvl(json, 1);

		if ( this.settings.formatCategoriesMode == "pick2" )
			return this.formatBrandCategoriesPickLvl(json, 2);

		return this.formatBrandCategoriesPickAll(json);
	}

	// ****************************************************************************************************
	// obróbka danych produktów
	// ****************************************************************************************************
	formatItems(data) {
		if ( data === false )
			return false;

		var json = toolsObj.stringToJson(data, this.testMode);
//console.log('formatItems',json);

		return json;
	}

	// ****************************************************************************************************
	// obróbka danych kategorii - TRYB ALL, czyli składanie dwoch poziomów
	// ****************************************************************************************************
	formatBrandCategoriesPickAll(json) {
		var obj;
		var jsonF = {};
		jsonF.elements = [];

		for ( var index in json.brandCategories ) {
			obj = json.brandCategories[index];

			if ( obj.poziom == "1" && obj.lisc == "false" && Array.isArray( obj.podkategorie ) ) {
				for ( var i in obj.podkategorie ) {
					obj.podkategorie[i].nazwa = obj.nazwa + " :: " + obj.podkategorie[i].nazwa;
					jsonF.elements.push(obj.podkategorie[i]);
				}
			} else {
				jsonF.elements.push(obj);
			}
		}

		return jsonF;
	}

	// ****************************************************************************************************
	// obróbka danych kategorii - TRYB PICK, czyli wybór poziomu
	// ****************************************************************************************************
	formatBrandCategoriesPickLvl(json, lvl) {
		var obj;
		var jsonF = {};
		jsonF.elements = [];

		for ( var index in json.brandCategories ) {
			obj = json.brandCategories[index];

			if ( obj["poziom"] == lvl || !Array.isArray( obj.podkategorie ) ) {
				jsonF.elements.push(obj);
			} else {
				for ( var i in obj.podkategorie ) {
					jsonF.elements.push(obj.podkategorie[i]);
				}
			}
		}

		return jsonF;
	}
}